<template>
  <v-badge offset-x="27px" offset-y="27px" color="primary">
    <template v-slot:badge>
      <file-upload
        ref="upload"
        v-model="files"
        v-bind="avatarUploadProps"
        @input-filter="inputFilter"
      >
        <v-icon color="white" size="20">mdi-camera-outline</v-icon>
      </file-upload>
    </template>
    <user-avatar
      avatar-size="100"
      icon-size="75"
      :url="files.length > 0 ? files[0].url : computedUrl || null"
      :user-id="userId"
    />
    <v-row justify="center" class="mt-0">
      <v-btn
        text
        color="primary"
        :disabled="files.length === 0 && !computedUrl"
        @click="clearFiles"
      >{{ $i18n.t(`settings.users.userAvatarDelete`) }}</v-btn>
    </v-row>
  </v-badge>
</template>
<script>
import FileUpload from 'vue-upload-component';
import UserAvatar from '@/components/settings/UserAvatar';
export default {
  components: {
    FileUpload,
    UserAvatar
  },
  props: {
    userId: {
      type: [String, Number]
    },
    url: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    avatarUploadProps: {
      maximum: 1
    },
    files: []
  }),
  computed: {
    computedUrl: {
      get() {
        return this.url;
      },
      set(nV) {
        this.$emit('update:url', nV);
      }
    },
    apiUrl() {
      return process.env.VUE_APP_API_URL;
    },
    token() {
      return this.$store.getters.getToken;
    }
  },
  methods: {
    clearFiles() {
      this.computedUrl = '';
      this.files = [];
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png)$/i.test(newFile.name)) {
          this.$root.$emit('showSnackbar', this.$i18n.t(`settings.users.avatarImageRequired`));
          return prevent();
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = '';
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .v-badge__badge {
    height: 26px;
    border-radius: 50%;
  }
}
</style>
